/* Reuse the main product form so quantity, variant and cart handling stay together. */
if (!customElements.get('nouricha-sticky-cart')) {
  customElements.define('nouricha-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.main = document.getElementById('MainContent');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      };
      this.button.addEventListener('click', () => {
        this.sync();
        if (this.restock && !this.button.disabled) {
          this.restock.scrollIntoView({ block: 'center', behavior: 'auto' });
          this.restock.focus({ preventScroll: true });
        } else if (!this.button.disabled) this.source.click();
        this.sync();
      });
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.main, { subtree: true, childList: true, attributes: true, characterData: true });
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      this.sync();
    }
    sync() {
      const product = this.main.querySelector('product-info[id^="MainProduct"]');
      this.source = product?.querySelector('product-form button[name="add"]');
      if (!this.source) { this.hidden = true; return; }
      const price = product.querySelector('[id^="price-"]');
      const currentPrice = price?.querySelector('.price--on-sale .price-item--sale') || price?.querySelector('.price-item--regular');
      this.querySelector('[data-sticky-price]').textContent = price?.classList.contains('hidden') ? '' : currentPrice?.textContent.trim() || '';
      let variant;
      try { variant = JSON.parse(product.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch {}
      this.querySelector('[data-sticky-title]').textContent = variant?.title && variant.title !== 'Default Title' ? variant.title : product.querySelector('h1')?.textContent.trim() || '';
      this.button.textContent = this.source.querySelector('span')?.textContent.trim() || this.source.textContent.trim();
      this.button.disabled = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true';
      this.restock = product.querySelector('.nr-restock');
      if (this.restock) {
        this.button.textContent = this.restock.dataset.stickyLabel;
        this.button.disabled = false;
      }
      this.button.setAttribute('aria-busy', String(!this.restock && this.source.classList.contains('loading')));
      const error = product.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
      const errorTarget = this.querySelector('[data-sticky-error]');
      errorTarget.textContent = error?.textContent.trim() || '';
      errorTarget.hidden = !errorTarget.textContent;
      this.hidden = !window.matchMedia('(max-width: 749px)').matches || (this.restock || this.source).getBoundingClientRect().bottom >= 0;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
    }
  });
}
